import React from 'react'
import PropTypes from 'prop-types'
import { StarIcon } from './icons'

/**
* Rating component for displaying product ratings with Stars.
*/
function Rating(props) {
  const {
    average, count, starCount, showCount, ...rest
  } = props

  /**
  * Renders the proper stars based on the given average rating.
  */
  const renderStars = () => {
    const value = String(average).split('.')
    let wholeCount = parseInt(value[0])


    let halfCount = 0

    // Figure out how many whole/half stars should be displayed.
    // A value of *.2 < n * < .8 is the current range for a half star to be
    // displayed, if less than that, then an empty star is displayed, and if
    // more than that, then a whole star is displayed.
    if (value[1]) {
      halfCount = parseInt(value[1][0])

      if (halfCount < 2) {
        halfCount = 0
      } else if (halfCount > 8) {
        wholeCount += 1
        halfCount = 0
      } else {
        halfCount = 1
      }
    }
    // Don't show any stars if there aren't any.
    if (!wholeCount) return false

    return [...Array(starCount).keys()]
      .map((x, idx) => {
        if (idx < wholeCount) {
          return <StarIcon isFull className="is-rating-star" key={idx} />
        } else if (idx < (wholeCount + halfCount)) {
          return <StarIcon isHalf className="is-rating-star" key={idx} />
        }

        return <StarIcon isEmpty className="is-rating-star" key={idx} />
      })
  }

  const classes = [
    'rating-stars',
    props.className ? props.className : '',
  ]

  return (
    <span {...rest} className={classes.join(' ')} aria-label={`${average} out of ${starCount} rating`}>
      {renderStars()}
      {(showCount && count) ? <span className="rating-count">{count}</span> : false}
    </span>
  )
}

Rating.defaultProps = {
  count: 0,
  starCount: 5,
  showCount: false,
}

Rating.propTypes = {
  // Value of rating to display.
  average: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  // Number of ratings.
  count: PropTypes.number,
  // if the number of ratings should be displayed.
  showCount: PropTypes.bool,
  // Max number of stars.
  starCount: PropTypes.number,
}

export default Rating
